import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-gosuslugi-ru.png'


const _hoisted_1 = {
  class: "q-pa-md q-mx-auto",
  style: {"min-width":"350px"}
}
const _hoisted_2 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "text-center" }, "Medsafe Router", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_btn, {
        push: "",
        size: "sm",
        type: "reset",
        color: "white",
        "text-color": "standard",
        href: `https://esia.medsafe.tech/${_ctx.hashLink}`,
        onClick: _ctx.setAppHash
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Войти через ", -1),
          _createElementVNode("img", {
            alt: "gu-logo",
            width: "100px",
            class: "q-ml-xs",
            src: _imports_0
          }, null, -1)
        ]))]),
        _: 1
      }, 8, ["href", "onClick"])
    ])
  ]))
}